import dayjs from "dayjs";

// constants
import { TAX_PERCENTAGE } from "../../constants/global";
import { pendingSkuReasons } from "../../constants/skus/pendingSkuReasons";
import { LAT_LNG_REGEX } from "../../constants/global";

// filter option in autoComplete
export const autoCompleteFilterOption = (inputValue, option) =>
  option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;

// filter option in select by label
export const selectFilterLabelOption = (inputValue, option) =>
  option.label?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;

// validate should enter value for form item
export const requiredValue = (rejectionMessage = "هذا الحقل مطلوب !") => {
  return {
    validator(name, value) {
      if (value) {
        return Promise.resolve();
      }

      return Promise.reject(rejectionMessage || `${name.field} is Required`);
    },
  };
};
export const validURL = (rejectionMessage = "الرابط غير صحيح") => {
  return {
    validator(name, value) {
      const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/i;

      if (urlRegex.test(value)) {
        return Promise.resolve();
      }

      return Promise.reject(
        rejectionMessage || `${name.field} is not a valid URL`
      );
    },
  };
};

export const requiredPhoneNumber = (
  rejectionMessage = "من فضلك أدخل رقم هاتف صحيح !"
) => {
  return {
    validator(name, value) {
      if (value && value.match(/^01[0125][0-9]{8}$/)) {
        return Promise.resolve();
      }

      return Promise.reject(rejectionMessage || `${name.field} is Required`);
    },
  };
};

export const requiredList = (rejectionMessage = "! هذا الحقل مطلوب") => {
  return {
    validator(_, list) {
      if (list && list.length > 0) {
        return Promise.resolve();
      } else {
        return Promise.reject(rejectionMessage);
      }
    },
  };
};

export const isInteger = (rejectionMessage = "من فضلك أدخل رقم صحيح") => {
  return {
    validator(_, value) {
      if (value && !/^\d+$/.test(value)) {
        return Promise.reject(rejectionMessage);
      } else {
        return Promise.resolve();
      }
    },
  };
};

export const isPositive = (
  rejectionMessage = "يجد ان تكون القيمة اكبر من 0"
) => {
  return {
    validator(_, value) {
      if (value && value <= 0) {
        return Promise.reject(rejectionMessage);
      } else {
        return Promise.resolve();
      }
    },
  };
};

export const notNegative = (
  rejMessage = "يجب أن تكون القيمة أكبر من أو تساوي 0"
) => {
  return {
    validator(_, value) {
      if (value < 0) {
        return Promise.reject(rejMessage);
      }

      return Promise.resolve();
    },
  };
};

export const lessThanOtherValue = (value, rejectionMessage) => {
  return {
    validator(_, inputValue) {
      if (inputValue < value) {
        return Promise.resolve();
      } else {
        return Promise.reject(rejectionMessage);
      }
    },
  };
};

// validate string not spaces
export const requiredStringValue = (rejectionMessage = "هذا الحقل مطلوب") => {
  return () => ({
    validator(_, value) {
      if (value && value.trim() !== "") {
        return Promise.resolve();
      }

      return Promise.reject(rejectionMessage);
    },
  });
};

export const requiredNationalId = (
  rejectionMessage = "من فضلك أدخل رقم قومي صحيح"
) => {
  return () => ({
    validator(_, value) {
      if (
        value &&
        value.match(
          /^([1-9])([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[01])([0-9]{6})([1-9])$/
        )
      ) {
        return Promise.resolve();
      }

      return Promise.reject(rejectionMessage);
    },
  });
};

// validate not duplicate values
export const notDuplicateValues = (
  fieldName,
  formItemName,
  rejectionMessage = "Duplicate values are not allowed."
) => {
  return ({ getFieldValue }) => ({
    validator(_, value) {
      if (
        getFieldValue(fieldName).filter((field) =>
          field && field[formItemName] ? field[formItemName] === value : false
        ).length > 1
      ) {
        return Promise.reject(new Error(rejectionMessage));
      } else {
        return Promise.resolve();
      }
    },
  });
};

export const priceShouldMatchOtherTiers = () => {
  return ({ getFieldValue }) => ({
    validator(name, value) {
      const [formListName, currentFormListItemName] = name.field.split(".");
      const currentTier = {
        price: value,
        quantity: getFieldValue([
          formListName,
          currentFormListItemName,
          "quantity",
        ]),
      };
      const otherTiers = getFieldValue(formListName);

      const foundMisMatch = otherTiers.find(
        (tier) =>
          currentTier.quantity > tier?.quantity &&
          currentTier.price >= tier?.price
      );
      if (foundMisMatch) {
        return Promise.reject("السعر أكبر من أو يساوي سعر كمية أقل !");
      }
      return Promise.resolve();
    },
  });
};

export function quantityShouldBeGreaterThanPreviousTier() {
  return ({ getFieldValue }) => ({
    validator(name, value) {
      const [formListName, currentFormListItemName] = name.field.split(".");
      const prevTier = getFieldValue([
        formListName,
        currentFormListItemName - 1,
      ]);
      if (prevTier && value - prevTier.quantity < 2) {
        return Promise.reject(
          `الكمية يجب أن تكون أكبر من أو تساوي ${prevTier.quantity + 2}`
        );
      }
      return Promise.resolve();
    },
  });
}

// disabled submit form when field form have errors
export const disabledSubmitForm = (form) => {
  return form.getFieldsError().filter(({ errors }) => errors.length).length;
};

// some pending sku reasons must have sku selected with them
export const disableSubmitPendingDetailsForSomeReasons = (skuId) => {
  return ({ getFieldValue, setFieldValue }) => ({
    validator(_, value) {
      const selectedReason = getFieldValue(`pendingReason_${skuId}`);
      if (
        selectedReason &&
        !pendingSkuReasons.find((reason) => reason.reason === selectedReason)
          .isSkuRequired
      ) {
        setFieldValue(`skuId_${skuId}`, null);
        return Promise.resolve();
      } else {
        if (!value) {
          return Promise.reject("Please, Select Sku For That Reason");
        } else {
          return Promise.resolve();
        }
      }
    },
  });
};

// filed value rule larger than another value
export const fieldValueShouldLargerOrEqual = (anotherValue, errorMessage) => ({
  validator(_, value) {
    if (value >= anotherValue) {
      return Promise.resolve();
    }

    return Promise.reject(errorMessage);
  },
});

// filed value rule less than another value
export const fieldValueShouldLessOrEqual = (anotherValue, errorMessage) => ({
  validator(_, value) {
    if (value <= anotherValue) {
      return Promise.resolve();
    }

    return Promise.reject(errorMessage);
  },
});

// validate no zero value accpeted
export const noZero = (rejectMessage) => {
  return () => ({
    validator(_, value) {
      if (value === 0) {
        return Promise.reject(rejectMessage);
      } else {
        return Promise.resolve();
      }
    },
  });
};

// field should be greater than other field
export const greaterThanOtherField = (
  fieldName,
  rejectMessage = "يجب أن تكون القيمة أكبر"
) => {
  return ({ getFieldValue }) => ({
    validator(_, value) {
      if (value <= getFieldValue(fieldName)) {
        return Promise.reject(rejectMessage);
      } else {
        return Promise.resolve();
      }
    },
  });
};

// field should be equal other field value
export const fieldValueShouldEqual = (fieldName, rejectMessage) => {
  return ({ getFieldValue }) => ({
    validator(_, value) {
      if (getFieldValue(fieldName) === value) {
        return Promise.resolve();
      }

      return Promise.reject(rejectMessage);
    },
  });
};

export const notEqualTo = (fieldName, rejectMessage) => {
  return ({ getFieldValue }) => ({
    validator(_, value) {
      if (getFieldValue(fieldName) !== value) {
        return Promise.resolve();
      }

      return Promise.reject(rejectMessage);
    },
  });
};

// validate fields values should equal value
export const fieldsValuesShouldEqualValue = (fieldName, value) => {
  return () => ({
    validator(_, fields) {
      if (
        fields.every((field) => field !== undefined) &&
        fields.reduce((acc, field) => acc + field[fieldName], 0) !== value
      ) {
        return Promise.reject(
          new Error("Total values not equal allowed value")
        );
      } else {
        return Promise.resolve();
      }
    },
  });
};

// validate suggested selling price
export const validateSuggestedSellingPrice = (buyingPrice, isTaxable) => {
  return () => ({
    validator(_, value) {
      if (isTaxable) {
        if (value < buyingPrice + TAX_PERCENTAGE * buyingPrice) {
          return Promise.reject(
            "سعر البيع قبل الخصم أقل من السعر التجاري للمركز + نسبة الضرائب (14%)"
          );
        }
      } else {
        if (value < buyingPrice) {
          return Promise.reject(
            "سعر البيع قبل الخصم أقل من السعر التجاري للمركز"
          );
        }
      }
      return Promise.resolve();
    },
  });
};

export const validateInput2faCode = () => {
  return {
    pattern: /^[0-9]*$/,
    message: "Enter Numbers Only",
  };
};

export const validLocation = (rejecMsg = "من فضلك أدخل موقع صحيح") => {
  return () => ({
    validator(_, value) {
      if (value && !value.match(LAT_LNG_REGEX)) {
        return Promise.reject(rejecMsg);
      }

      return Promise.resolve();
    },
  });
};

export const requiredTransferArrayValue = (
  rejectionMessage = "Please select at least one item"
) => {
  return {
    required: true,
    message: rejectionMessage,
    type: "array",
  };
};

export function numericValue(rejMsg = "Value must be a valid number") {
  return {
    validator(_, value) {
      if (value === "" || isNaN(Number(value))) {
        return Promise.reject(rejMsg);
      }

      return Promise.resolve();
    },
  };
}

export const dateGreaterThan = (fieldName, rejecMsg, format) => {
  return ({ getFieldValue }) => {
    let dateToCompare = fieldName ? getFieldValue(fieldName) : dayjs(); // if fieldName equals to null, then we compare to now
    if (format) {
      dateToCompare = dayjs(dateToCompare.format(format));
    }
    return {
      validator(_, value) {
        if (format) {
          value = dayjs(value.format(format));
        }

        if (dateToCompare && value && !value.isAfter(dateToCompare)) {
          return Promise.reject(rejecMsg);
        }

        return Promise.resolve();
      },
    };
  };
};

export const dateLessThan = (fieldName, rejecMsg, format) => {
  return ({ getFieldValue }) => {
    let dateToCompare = fieldName ? getFieldValue(fieldName) : dayjs(); // if fieldName equals to null, then we compare to now
    if (format) {
      dateToCompare = dayjs(dateToCompare.format(format));
    }
    return {
      validator(_, value) {
        if (format) {
          value = dayjs(value.format(format));
        }

        if (dateToCompare && value && !value.isBefore(dateToCompare)) {
          return Promise.reject(rejecMsg);
        }

        return Promise.resolve();
      },
    };
  };
};

export function spaceSeparatedNums(
  rejMsg = "Please, Type valid numbers with a space between each one"
) {
  return {
    validator(_, value) {
      if (!/^(?=.*\d)[1-9]\d*(?:\s[1-9]\d*)*$/.test(value)) {
        return Promise.reject(rejMsg);
      }

      return Promise.resolve();
    },
  };
}

export function max(maxVal, rejMsg) {
  return {
    validator(_, value) {
      if (value > maxVal) {
        return Promise.reject(rejMsg);
      }
      return Promise.resolve();
    },
  };
}

export const requiredNumber = (
  rejectionMessage = "This field is required!"
) => {
  return {
    validator(_, value) {
      if (typeof value === "number" && !isNaN(value) && value >= 0) {
        return Promise.resolve();
      }
      return Promise.reject(rejectionMessage);
    },
  };
};
